import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Copied from dataset-search-frontend/src/lib/utils/style.ts
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
